export default ({ request }) => ({
  techInfoListApi(data = {}) {
    return request({
      url: '/factory/tech/info/list',
      method: 'post',
      data,
    })
  },
  techInfoDetailApi(data = {}) {
    return request({
      url: '/factory/tech/info/detail',
      method: 'post',
      data,
    })
  },
  techInfoSaveApi(data = {}) {
    return request({
      url: '/factory/tech/info/save',
      method: 'post',
      data,
    })
  },
  techInfoDelApi(data = {}) {
    return request({
      url: '/factory/tech/info/del',
      method: 'post',
      data,
    })
  },
  techInfoAuditApi(data = {}) {
    return request({
      url: '/factory/tech/info/audit',
      method: 'post',
      data,
    })
  },
  techInfoSameCopyApi(data = {}) {
    return request({
      url: '/factory/tech/info/same/copy',
      method: 'post',
      data,
    })
  },
  techInfoDifferentCopyApi(data = {}) {
    return request({
      url: '/factory/tech/info/different/copy',
      method: 'post',
      data,
    })
  },
  // tech_processes
  techProcessesListApi(data = {}) {
    return request({
      url: '/factory/tech/processes/list',
      method: 'post',
      data,
    })
  },
  techProcessesDetailApi(data = {}) {
    return request({
      url: '/factory/tech/processes/detail',
      method: 'post',
      data,
    })
  },
  techProcessesSaveApi(data = {}) {
    return request({
      url: '/factory/tech/processes/save',
      method: 'post',
      data,
    })
  },
  techProcessesDelApi(data = {}) {
    return request({
      url: '/factory/tech/processes/del',
      method: 'post',
      data,
    })
  },
  techProcessesUpdateSortApi(data = {}) {
    return request({
      url: '/factory/tech/processes/update/sort',
      method: 'post',
      data,
    })
  },
})
